/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { ISafe__factory } from "./ISafe__factory";
